/**
 * Per huishouden het woord en de kleur van zijn status, klaar om in het
 * agendablok van een huisbezoek te tekenen.
 *
 * Eén keer uitrekenen per scherm en als prop meegeven; `CalendarView` zoekt er
 * per blok alleen in op `AdressID`.
 *
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 */

/**
 * @typedef {object} AdressStatusBadge
 * @property {string} label - Het woord dat de organisatie voor de status gebruikt
 * @property {string} color - Een kleur uit `PALETTE_COLORS` (CSS-klasse `status-dot--<kleur>`)
 */

/**
 * @param {Array<{ID?: string, Status?: string}>|undefined|''} adresses - De huishoudens; niet-array = nog onderweg
 * @param {{labels: Record<string, string>}} display - Uitkomst van `resolveStatusDisplay` voor huishoudens
 * @param {Record<string, string>} colors - Uitkomst van `resolveStatusColors`
 * @returns {Record<string, AdressStatusBadge>}
 */
const buildAdressStatusById = (adresses, display, colors) => {
    if (!Array.isArray(adresses)) return {}
    const labels = (display && display.labels) || {}
    const palette = colors || {}

    return adresses.reduce((acc, adress) => {
        const id = adress && adress.ID
        const status = adress && adress.Status
        if (!id || !status) return acc
        // Een status die de code niet (meer) kent krijgt zijn eigen sleutel als
        // woord en grijs als kleur: de lezer ziet wat er staat in plaats van
        // niets. Zelfde keuze als `statusOptionsFor`.
        acc[id] = {
            label: labels[status] || status,
            color: palette[status] || 'grey',
        }
        return acc
    }, {})
}

export default buildAdressStatusById
